import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { first, map, mergeMap } from 'rxjs/operators';

import { TrackingAction } from 'src/app/core/services/tracking/models/tracking-action.enum';
import { TrackingCategory } from 'src/app/core/services/tracking/models/tracking-category.enum';
import { TrackingEventType } from 'src/app/core/services/tracking/models/tracking-event-type.enum';
import { TrackingInput } from 'src/app/core/services/tracking/models/tracking-object.interface';
import { TrackingService } from 'src/app/core/services/tracking/tracking.service';

import { SimsearchService } from '../simsearch.service';
import { SimsearchActionType } from './simsearch.actions';

@Injectable()
export class SimsearchTrackingEffects {
  public trackSimsearchInViewport$: Observable<void> = createEffect(
    (): Observable<void> =>
      this.actions$.pipe(
        ofType(SimsearchActionType.InViewport),
        mergeMap(() => this.simsearchService.similarVehicles$),
        first(),
        map(vehicles => {
          const trackingInput: TrackingInput = {
            event: TrackingEventType.Click,
            clickData: {
              label: `mmf_${Math.round(
                vehicles.flatMap(vehicle => vehicle.matchFactor).reduce((a, b) => a + b) / vehicles.length
              )}`,
              category: TrackingCategory.Impression,
              action: TrackingAction.SimSearch
            }
          };
          this.trackingService.sendTrackingData(trackingInput);
        })
      ),
    { dispatch: false }
  );

  public constructor(
    private readonly actions$: Actions<any>,
    private readonly trackingService: TrackingService,
    private readonly simsearchService: SimsearchService
  ) {}
}
